import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <ContactSection />
        <AboutSection />
        <FeaturesSection />
        <UpdatesSection />
        <TopicsSection />
        <CommentsSection />
        <AppSection />
        <CarouselSection />
        <IndexSection />
        <CardsSection />
        <MediaSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}